export const PWA = {
  banner: "pwa-banner",
  bannerInstall: "pwa-banner-install",
  bannerDismiss: "pwa-banner-dismiss",
  iosSheet: "pwa-ios-sheet",
  iosClose: "pwa-ios-close",
  accountInstall: "pwa-account-install",
  profileSection: "pwa-profile-section",
  profileInstall: "pwa-profile-install",
  prefDaily: "pwa-pref-daily",
  prefWeekly: "pwa-pref-weekly",
  pushSheet: "pwa-push-sheet",
  pushAllow: "pwa-push-allow",
  pushLater: "pwa-push-later",
  testPush: "pwa-test-push",
};
